// objj.CreatedBy = Number(sessionStorage.getItem("UID"));
// Set-ExecutionPolicy -Scope Process -ExecutionPolicy RemoteSigned
import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FaqComponent } from './faq/faq.component';
import { ShopGridComponent } from './shop-grid/shop-grid.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { LoginComponent } from './login/login.component';
import { WishlistComponent } from './wishlist/wishlist.component';
import { SingleProductComponent } from './single-product/single-product.component';
import { DeliverytermsComponent } from './deliveryterms/deliveryterms.component';
import { ReturnpolicyComponent } from './returnpolicy/returnpolicy.component';
import { PaymenttermsComponent } from './paymentterms/paymentterms.component';
import { BlogComponent } from './blog/blog.component';

import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { SecurityComponent } from './security/security.component';

import { ShopGridDealofthedayComponent } from './shop-grid-dealoftheday/shop-grid-dealoftheday.component';
import { ShopGridBulkorcorporateorderComponent } from './shop-grid-bulkorcorporateorder/shop-grid-bulkorcorporateorder.component';

import { VisitorsvisionComponent } from './visitorsvision/visitorsvision.component';
import { AddressComponent } from "./address/address.component";
import { OrdersComponent } from './orders/orders.component';

import { UpdateprofileComponent } from './updateprofile/updateprofile.component';
import { ProceedpaymentComponent } from './proceedpayment/proceedpayment.component';

//import { ContactUsComponent } from './contact-us/contact-us.component';
import { ConditionsofUseComponent } from './conditionsof-use/conditionsof-use.component';
import { RefundsOrCancellationsComponent } from './refunds-or-cancellations/refunds-or-cancellations.component';
import { ThankingyouComponent } from './thankingyou/thankingyou.component';
import { HideandskincustomizationComponent } from './hideandskincustomization/hideandskincustomization.component';
import { HideandskindemandComponent } from './hideandskindemand/hideandskindemand.component';
import { CustomeropinionComponent } from './customeropinion/customeropinion.component';
import { HideandskincustomeropinionComponent } from './hideandskincustomeropinion/hideandskincustomeropinion.component';
import { SearchproductsComponent } from './searchproducts/searchproducts.component';
import { SearchBarComponent } from './search-bar/search-bar.component';



export const AppRoutes: Routes = [

    {
        path: "",
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: "home",
        component: HomeComponent
    },
    {
        path: "faq",
        component: FaqComponent
    },
    {
        path: "shop-grid",
        component: ShopGridComponent
    },
    {
        path: "about",
        component: AboutUsComponent
    },
    {
        path: "cart",
        component: CartComponent
    },
    {
        path: "checkout",
        component: CheckoutComponent
    },

    // {
    //     path: 'shop-grid',
    //     component: ShopGridComponent
    // },

    { path: "shop-grid/:itemCategory",
    component: ShopGridComponent },


    {
        path: "contact-us",
        component: ContactUsComponent
    },
    {
        path: "error",
        component: ErrorPageComponent
    },
    {
        path: "login",
        component: LoginComponent
    },
    {
        path: "wishlist",
        component: WishlistComponent
    },
    // {
    //     path: 'single-product',
    //     component: SingleProductComponent
    // },
    {
        path: "single-product/:itemId",
        component: SingleProductComponent,
      },
    {
        path: "deliveryterms",
        component: DeliverytermsComponent
    },

    {
        path: "returnpolicy",
        component: ReturnpolicyComponent
    },
    {
        path: "paymentterms",
        component: PaymenttermsComponent
    },
    {
        path: "blog",
        component: BlogComponent
    },
    {
        path: "privacypolicy",
        component: PrivacypolicyComponent
    },
    {
        path: "security",
        component: SecurityComponent
    },
    {
        path: "dealoftheday",
        component: ShopGridDealofthedayComponent
    },
    {
        path: "bulkorcorporateorder",
        component: ShopGridBulkorcorporateorderComponent
    },
    {
        path: "visits",
        component: VisitorsvisionComponent
    },
    {
        path: "address",
        component: AddressComponent,
    },
    {
        path: "orders",
        component: OrdersComponent,
    },
    {
        path: "updateprofile",
        component: UpdateprofileComponent,
    },
    {
        path: "proceedpayment",
        component: ProceedpaymentComponent,
    },
    {
        path: "conditionsof-use",
        component: ConditionsofUseComponent,
    },
    {
        path: "refunds-or-cancellations",
        component: RefundsOrCancellationsComponent,
    },
    {
      path: "thankingyou",
      component: ThankingyouComponent,
    },
    {
        path: "hideandskincustomization",
        component: HideandskincustomizationComponent,
    },
    {
        path: "hideandskincustomeropinion",
        component: HideandskincustomeropinionComponent,
    },
    
    {
        path: "searchproducts",
        component: SearchproductsComponent,
    },

    {
        path: "search-bar",
        component: SearchBarComponent,
    },

     //   import { SearchproductsComponent } from './searchproducts/searchproducts.component';
  
    // import { CustomeropinionComponent } from './customeropinion/customeropinion.component';
   

    {
        path: "**",
        redirectTo: 'error'
    }



]
